import './styles.scss'
import formatClasses from '../../utils/classes/formatClasses'
import { ReactNodeProps } from '../../types/reactNodeProps'
import { motion } from 'motion/react'

export interface Props extends ReactNodeProps {
  size?: 'sm' | 'md' | 'lg'
  layoutId?: string
  animate?: any
  transition?: any
  initial?: any
}

const defaultProps: Partial<Props> = {
  size: 'md',
}

export default function Bar(props: Props) {
  props = { ...defaultProps, ...props }

  const classes = formatClasses([
    props.className,
    'bar',
    props.size,
    props.children ? 'has-children' : undefined,
  ])

  return (
    <motion.div
      className={classes}
      style={props.style}
      layoutId={props.layoutId}
      animate={props.animate}
      initial={props.initial}
      transition={
        props.transition || { type: 'spring', stiffness: 120, damping: 20 }
      }
    >
      {props.children}
    </motion.div>
  )
}
